import { useDispatch, useSelector } from "react-redux";

export default function useCustomerFilters() {
  const dispatch = useDispatch();
  const setState = (payload) => dispatch({ type: "CUSTOMER_TAB", payload });
  const data = useSelector((state) => state.customerTab);
  const { showExtraFilters } = data;

  const onDatesChange = (_, { name, value }) =>
    setState({ [name]: value, pageNumber: 1 });

  const onCustomerStateChange = (_, { value }) =>
    setState({ selectedCustomerState: value, pageNumber: 1 });

  const toggleExtraFilters = () =>
    setState({ showExtraFilters: !showExtraFilters });

  return {
    ...data,
    onDatesChange,
    onCustomerStateChange,
    toggleExtraFilters,
  };
}
